export const SIDE_DRAWER_WIDTH = 305;
export const LAYOUT_PADDING = { xs: '10px 20px 6px 20px', sm: '16px 15px 16px 320px', md: '16px 20px 16px 330px', xl: '16px 20px 16px 325px' };
export const SHADOWS = {
  light: ' 0 2px 3px rgba(0, 0, 0, 0.1)'
};
export const CREATOR_FEED_WIDTH = Object.freeze({ xs: '382px', xsm: '779px', mds: '1044px', sm: '1043px', lg: '1308px', xl: '1570px', xxl: '1835px' });
export const TOP_CREATOR_FEED_WIDTH = Object.freeze({ xs: '382px', xsm: '779px', mds: '1044px', sm: '1043px' });